import { render, staticRenderFns } from "./leftCenter.vue?vue&type=template&id=fd2e0344&scoped=true&"
import script from "./leftCenter.vue?vue&type=script&lang=js&"
export * from "./leftCenter.vue?vue&type=script&lang=js&"
import style0 from "./leftCenter.vue?vue&type=style&index=0&id=fd2e0344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2e0344",
  null
  
)

export default component.exports